import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';
import { setStatus } from '@cotyorg/ccx-molecules/Modal/modules';
import { CLOSE_START } from '@cotyorg/ccx-molecules/Modal/modules/status';
import {
  toggleFilter as toggleFilterAction,
  setSelectedFilters as setSelectedFiltersAction,
  toggleFilterCategory as toggleFilterCategoryAction,
} from '../modules';

const FilterContainer = ({
  childComponent: ChildComponent,
  ...props
}) => (
  <ChildComponent
    {...props}
  />
);

const mapStateToProps = ({ filter = {}, content, breakpoints = {} }, { isVariantFilter }) => ({
  filterContent: R.propOr(
    {},
    (isVariantFilter && R.has('variantFilter', content)) ? 'variantFilter' : 'filter',
  )(content),
  filterData: filter,
  currentBreakpoint: breakpoints.current,
});

const mapDispatchToProps = dispatch => ({
  toggleFilter: ({ categoryName, optionName }) => dispatch(toggleFilterAction({ categoryName, optionName })),
  setSelectedFilters: selectedFilters => dispatch(setSelectedFiltersAction({ selectedFilters })),
  toggleFilterCategory: categoryName => dispatch(toggleFilterCategoryAction({ categoryName })),
  closeModal: id => dispatch(setStatus({ id, status: CLOSE_START })),
});

FilterContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterContainer);
